import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[greaterThan]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: GreaterThanValidator, multi: true }
    ],
    standalone: false
})
export class GreaterThanValidator extends BaseValidator implements OnChanges {

  @Input('greaterThan')
  otherValue: string;

  @Input()
  comparisonType: string;

  @Input()
  fieldName: string;

  @Input()
  errorMessage: string;

  constructor() {
    super('greaterThan');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.otherValue && changes.otherValue.isFirstChange()) {
      return;
    }

    this._onChange();
  }

  protected getValidationResult(control: any) {
    if (control.value == null || this.otherValue == null) {
      return null;
    }

    let firstValue: any = control.value;
    let secondValue: any = this.otherValue;
    if (this.comparisonType === "Date") {
      firstValue = new Date(control.value);
      secondValue = new Date(this.otherValue);
    }

    if (firstValue > secondValue)
      return null;

    let validationResult = { 'greaterThan': { fieldName: this.fieldName, error: null } };

    if (this.errorMessage) {
      validationResult.greaterThan.error = this.errorMessage;
    }

    return validationResult;
  }
}
